var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consult-embed"},[_c('AiConsultChat',{attrs:{"embed":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }